import { FC, useEffect } from 'react';
import Button from '../Button';
import { Table, TableColumnsType } from 'antd';
import { IFeedbackTask } from '../../models/tutor.model';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface IProps {
  data: IFeedbackTask[]|undefined;
  doGetFeedbackTasks: () => void;
}

const ELearningTable: FC<IProps> = ({
  data,
  doGetFeedbackTasks,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);
    return () => window.removeEventListener("message", receiveMessage);
  }, []);

  const receiveMessage = (event: any) => {
    if (event.data === 'success') {
      doGetFeedbackTasks();
    }
  }  

  const columns: TableColumnsType<IFeedbackTask> = [
    {
      title: t('class.tutor.column6'),
      dataIndex: 'feedbackTypeCode',
      key: 'feedbackTypeCode',
      align: 'center',
      render: value => value === 'ST' ? 'Speaking' : 'Writing',
    },
    {
      title: t('common.column.category'),
      dataIndex: 'displayName',
      key: 'displayName',
      align: 'center',
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
    },
    {
      title: t('common.menu.student'),
      dataIndex: 'studentKorName',
      key: 'studentKorName',
      align: 'center',
    },
    {
      title: t('common.menu.studentEng'),
      dataIndex: 'studentEngName',
      key: 'studentEngName',
      align: 'center',
    },
    {
      title: t('common.column.date1'),
      dataIndex: 'regDate',
      key: 'regDate',
      align: 'center',
      render: value => moment(value, 'YYYYMMDD').format('YYYY.MM.DD'),
    },
  ];

  return (
    <>
      <div className="comm-bx__between">
        <div className="comm-sch_result"><b>{t('common.menu.elearning')}</b></div>
        <div className="comm-btn__area">
          <Button
            className="btn-basic pink"
            text="More"
            onClick={() => history.push('/class/feedback')}
          />
        </div>
      </div>
      <div className='comm-table__area mt-0'>
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: 1,
            pageSize: 5,
          }}
          onRow={(record) => {
            return {
              onClick: () => {
                if(record.activityType === 'AC') {
                  window.open(`/assess-cb?rubricNo=${record.rubricNo}&resultCode=${record.resultCode}&learningTlStructureNo=${record.learningTlStructureNo}&seq=${record.seq}&activityCode=${record.activityCode}&curriculumName=${record.curriculumName}&studentKorName=${record.studentKorName}&studentEngName=${record.studentEngName}&regDate=${record.regDate?.trim()}&displayName=${record.displayName}&activityName=${record.activityName}&activityType=${record.activityType}&feedbackTypeCode=${record.feedbackTypeCode}&eduStepCode=${record.eduStepCode}&canbotTopic=${record.canbotTopic}&className=${record.className}`, '_blank');
                } else {
                  window.open(`/assess?rubricNo=${record.rubricNo}&resultCode=${record.resultCode}&learningTlStructureNo=${record.learningTlStructureNo}&seq=${record.seq}&activityCode=${record.activityCode}&curriculumName=${record.curriculumName}&studentKorName=${record.studentKorName}&studentEngName=${record.studentEngName}&regDate=${record.regDate?.trim()}&displayName=${record.displayName}&activityName=${record.activityName}&activityType=${record.activityType}&feedbackTypeCode=${record.feedbackTypeCode}&eduStepCode=${record.eduStepCode}`, '_blank');
                }
              },
            };
          }}
          rowClassName="pointer"
        />
      </div>
    </>
  );
};

export default ELearningTable;
